export const regexes = {
  EMAIL:
    /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
  SIGNINPASSWORD: /^.{1,}$/,
  CONFIRMPAYMENTPASSWORD: /^.{1,}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,24}$/,
  // PASSWORD: /^(?=.{8,}$)(?=.*[A-Z])(?=.*[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]+$/,
  // TEMPPASSWORD: /^.{12,16}$/,
  // OTP: /^\d{6}$/,
  // KEYDOWNOTP: /^\d{1,6}$/,
  PASSWORDPATTERNLENGTH: /^.{8,24}$/,
  PASSWORDPATTERNUPPERCASE: /[A-Z]/,
  PASSWORDPATTERLOWERCASE: /[a-z]/,
  // PASSWORDPATTERNSPECCHAR: /[!@#$%^&*()]/,
  PASSWORDPATTERNDIGIT: /\d/,
  // ROMANIANLATINALPHANUMERIC: /^[a-zA-Z0-9ȘșȚțĂăÎîÂâ]*$/u,
  PASSWORDTOKEN:
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  VALIDATIONPATTERNDIGITS: /^[0-9]+$/,
  VALIDATIONPATTERNIDNO: /^(\d{13})?$/,

  REPLACENONDIGITS: /[^0-9]/g,

  // ALPHADASH: /^[a-zA-Z\-]+$/,
  // ALPHANUMERIC: /[^a-zA-Z0-9\,.\s]/,
  // COUNTERPARTYNAME: /^[a-zA-Z0-9\s\-]+$/,
  // NAMESURNAME: /^[a-zA-Z]+(?:-[a-zA-Z]+)* [a-zA-Z]+(?:-[a-zA-Z]+)*$/,
  // KEYPRESSNAMESURNAME: /^[a-zA-Z\-\s]+$/,
  // NUMBER: /^[-+]?\d+(\.\d+)?$/,
  // IDNO: /^[0-9]+$/,
  // IDNP: /^\d{13}$/,
  // KEYPRESSDIGITS: /^[0-9]+$/,
  // NONCYRILLIC: /^((?![а-яА-ЯёЁ]).)*$/,
  // PREFIXMOBILENR: /^373(7|6)[0-9]{7}$/,
  // PHONENR: /^(7|6)[0-9]{7}$/,
  // ADDRESS: /^[0-9A-Za-z\s\-\,\.\/]+$/,
  // PHONENUMBER: /^[0-9+\-\(\)]{5,20}$/,
  // KEYPRESSEMAIL: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~@\-]+$/,
  // // для new Regexp(),  \\s ставлю специально , при сохранении \s превращается в s - и регулярка не работает
  // PASTEIDNO: '^[0-9\\s]+$',
  // PASTEIBAN: '^[A-Z0-9\\s]+$',
  // //Regex For Sepa Create Account
  // GIINNUMBER: /^\d{6}\.[A-Za-z0-9]{5}\.[A-Za-z]{2}\.\d{3}$/,
  // WEBSITE: /^https?:\/\/(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z/.]{2,})+$/,
  // SEPACOMPANYNAME: /^[A-Za-z0-9\-\(\)\.,' ]*$/,
  // COUNTYCODE: /^[A-Z]{2}$/,
  // SEPANAMELASTNAME: /^[A-Za-z\-\.' ]*$/,
  // ZIPCODE: /^(MD-?)?\d{4}$/,
};
